module.exports = __webpack_public_path__ + "static/services-image-4_m-716151dc03bf9e70462017339f61b35f.jpg";